import React, { useState, useEffect } from "react";
import { useMultiLang } from "../../services/GlobalUtil";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../../services/api";
import FunctionButton from "../../components/common/FunctionButton";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import MessageDialog from "../../components/common/MessageDialog";
import FunctionDialog from "../../components/common/FunctionDialog";
import ContentInput from "../../components/common/ContentInput";
import ValidMsgSpan from "../../components/common/ValidMsgSpan";

const MyPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const verifyEmail =
    /([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

  const [data, setData] = useState("");
  const [email, setEmail] = useState("");
  const [language, setLanguage] = useState("");
  const [curPwd, setCurPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [cfmNewPwd, setCfmNewPwd] = useState("");

  const sbLanguage = [...useMultiLang("LANG")];

  const [isPwDialogOpen, setIsPwDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorDialogMsg, setErrorDialogMsg] = useState(false);
  const [isSuccessDialogOpen, setIsSuccessDialogOpen] = useState(false);

  useEffect(() => {
    if (!JSON.parse(sessionStorage.getItem("userInfo")).userId) {
      navigate("/login");
    }

    api
      .post("/mypage/detail", {
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
      })
      .then((response) => {
        setData(response.data);
        setEmail(response.data.email);
        setLanguage(response.data.language);
      })
      .catch((error) => {
        if (error.response && error.response.data.result == 999) {
          navigate("/mypage/checkpw");
        }
      });
  }, []);

  const handleChangePw = () => {
    setIsPwDialogOpen(true);
  };

  const handleCancel = () => {
    setIsPwDialogOpen(false);
    setCurPwd("");
    setNewPwd("");
    setCfmNewPwd("");
  };

  const handleConfirm = () => {
    setIsSuccessDialogOpen(false);
    navigate("/pdi-status/regional-record");
  };

  const handleChangePwdSubmit = () => {
    if (!validate()) {
      return;
    }

    api
      .post("/mypage/changepwd", {
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        userPwd: curPwd,
        newPwd: newPwd,
      })
      .then(() => {
        setIsPwDialogOpen(false);
        setCurPwd("");
        setNewPwd("");
        setCfmNewPwd("");
        setIsSuccessDialogOpen(true);
      })
      .catch((error) => {
        if (error.response.data.result == "1014") {
          setErrorDialogMsg(t("L1089"));
          setIsErrorDialogOpen(true);
        }
      });
  };

  const handleSubmit = () => {
    if (!email || !language) {
      return;
    }

    if (!verifyEmail.test(email)) {
      setErrorDialogMsg(t("L0024"));
      setIsErrorDialogOpen(true);
      return;
    }

    api
      .post("/mypage/update", {
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        email: email,
        language: language,
      })
      .then(() => {
        setIsSuccessDialogOpen(true);
      })
      .catch((error) => {
        if (error.response.data.result == "1035") {
          setErrorDialogMsg(t("L0022"));
          setIsErrorDialogOpen(true);
        }
      });
  };

  const [error, setError] = useState(t("L0018"));

  const validate = () => {
    let isValid = false;
    let regex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-_])(?=.*[0-9]).{8,20}$/;

    if (!curPwd || !newPwd || !cfmNewPwd) {
      setError(t("L0042"));
      return isValid;
    }

    if (!regex.test(newPwd)) {
      setError(t("L0018"));
      return isValid;
    }

    if (newPwd != cfmNewPwd) {
      setError(t("L0042"));
      return isValid;
    }

    isValid = true;
    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("L0045")]}></BreadCrumbDiv>

      <ListWrapDiv className={"list_hori"}>
        <table style={{ tableLayout: "fixed" }}>
          <colgroup>
            <col style={{ width: "20%" }} />
            <col style={{ width: "30%" }} />
            <col style={{ width: "20%" }} />
            <col style={{ width: "30%" }} />
          </colgroup>
          <tbody>
            <tr>
              <th>{t("L0002")}</th>
              <td>
                <label>{data.userId}</label>
              </td>
              <th>{t("L0003")}</th>
              <td>
                <ContentInput
                  value={email}
                  onChange={(e) => setEmail(e.target.value.trim())}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>{t("L0657")}</th>
              <td>
                <CodeSelectBox
                  value={language}
                  codes={sbLanguage}
                  onChange={(event) => setLanguage(event.target.value)}
                  width="100%"
                  style={{ border: "0.5px solid lightgray" }}
                ></CodeSelectBox>
              </td>
              <th>{t("L0027")}</th>
              <td>
                <FunctionButton
                  value={t("L0038")}
                  className="w50"
                  onClick={() => handleChangePw(data.userId)}
                />
              </td>
            </tr>
            <tr>
              <th>{t("L0085")}</th>
              <td colSpan={3}>
                <label>{data.locDesc}</label>
              </td>
            </tr>
          </tbody>
        </table>

        <ButtonWrapDiv className="btn_bottom">
          <FunctionButton
            className="big"
            value={t("L0659")}
            onClick={handleSubmit}
          ></FunctionButton>
        </ButtonWrapDiv>
      </ListWrapDiv>

      {isPwDialogOpen && (
        <FunctionDialog
          title={"Information"}
          body={
            <ListWrapDiv className={"list_hori"}>
              <table style={{ tableLayout: "fixed" }}>
                <colgroup>
                  <col style={{ width: "50%" }} />
                  <col style={{ width: "50%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>{t("L0039")}</th>
                    <td>
                      <ContentInput
                        type="password"
                        maxLength={250}
                        value={curPwd}
                        onChange={(e) => setCurPwd(e.target.value.trim())}
                      ></ContentInput>
                    </td>
                  </tr>
                  <tr>
                    <th>{t("L0038")}</th>
                    <td>
                      <ContentInput
                        type="password"
                        maxLength={250}
                        value={newPwd}
                        onChange={(e) => setNewPwd(e.target.value.trim())}
                      ></ContentInput>
                    </td>
                  </tr>
                  <tr>
                    <th>{t("L0041")}</th>
                    <td>
                      <ContentInput
                        type="password"
                        maxLength={250}
                        value={cfmNewPwd}
                        onChange={(e) => setCfmNewPwd(e.target.value.trim())}
                      ></ContentInput>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      {error && <ValidMsgSpan value={error}></ValidMsgSpan>}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ListWrapDiv>
          }
        >
          <FunctionButton
            className="big"
            color="bg_gray"
            value={t("L0005")}
            onClick={handleCancel}
          ></FunctionButton>
          <FunctionButton
            className="big"
            value={t("L0659")}
            onClick={handleChangePwdSubmit}
          ></FunctionButton>
        </FunctionDialog>
      )}

      {isErrorDialogOpen && (
        <MessageDialog title={t("L0339")} message={errorDialogMsg}>
          <FunctionButton
            value={t("L0004")}
            onClick={() => setIsErrorDialogOpen(false)}
          ></FunctionButton>
        </MessageDialog>
      )}

      {isSuccessDialogOpen && (
        <MessageDialog title={t("L0339")} message={t("L0103")}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default MyPage;
